// ClientViewVideosModal.jsx
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Modal, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_CLIENT_VIDEOS } from "../../constant/Apipath";
import { BILightGrey } from "../../assets/helpers";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { VPlayer } from "./VPlayer";
import { VideoDetails } from "./VideoDetails";
import { VideosList } from "./VideosList";

export const ClientViewVideosModal = ({ isOpen, onClose, data }) => {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const [loading, setLoading] = useState(false);
  const [videosList, setVideosList] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);
  const LANGUAGE = ClientEnglishFallback?.ClientVideos(multiLanguageData?.ClientVideos || {});

  useEffect(() => {
    if (isOpen) {
      if (currentVideo == null) {
        setCurrentVideo(data);
      }
      fetchVideos();
    }
  }, [isOpen]);

  const fetchVideos = async () => {
    setLoading(true);
    const searchObj = {
      PageNr: 1,
      NrOfRecPerPage: 20,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SortList: [{ FieldName: "id", Order: "DESC" }],
      SearchList: [{ categoryId: data?.categoryId ?? null }]
    };

    try {
      const res = await Postrequestcall(FETCH_CLIENT_VIDEOS, searchObj, loginData?.accessToken);
      if (res?.status === 200) {
        const filteredVideos = res?.data?.data?.filter(video => video?.id !== currentVideo?.id);
        setVideosList(filteredVideos);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleVideoSelect = (video) => {
    setCurrentVideo(video);
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="client-modal-responsive" style={{ height:"94vh", overflow:'scroll' }}>
        <div className="action-button-container">
          <div></div>
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              color: selectedClientData?.AccentColor || BILightGrey
            }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <div style={{ borderRadius: "10px", overflow: "hidden", }}>
          <VPlayer
            isVisible={isOpen}
            source={{
              src: currentVideo?.fileName,
              type: "application/x-mpegURL"
            }}
          />
        </div>

        <VideoDetails video={currentVideo} />
        
        <VideosList 
          videos={videosList}
          onVideoSelect={handleVideoSelect}
          loading={loading}
          moreVideosText={LANGUAGE.TEXT_MORE_VIDEOS}
        />
      </div>
    </Modal>
  );
};
